import { createContext } from 'react';
import { UsersHostProps } from './types';
import useUsersList from './useUsersList';

/** The host props plus the account's user list, which the provider fetches once for every part of the feature. */
export type UsersContextValue = Omit<UsersHostProps, 'title' | 'titleLevel'> & ReturnType<typeof useUsersList>;

export const UsersContext = createContext<UsersContextValue | null>(null);
